import React, {  useMemo, useState } from "react";
import { SUB } from "../../../../../shared/Data/typeDirs";
import { Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { useSource } from "../../../sourceContext";

export function LangEntrySelector({ onSelect, type, _subcategories, }) {
  const source = useSource()
  const [filter, setFilter] = useState('')
  const [showMenu, setShowMenu] = useState(false)
  const [showAllLanguageEntries, setShowAllLanguageEntries] = useState(false)
  

  function isFilterMatch(langEntry, f) {
    return langEntry.short.toLowerCase().includes(f.toLowerCase()) || langEntry.content.toLowerCase().includes(f.toLowerCase())
  }

  const langEntrySelectorComponent = useMemo(()=>{
    
    const langEntries = showAllLanguageEntries ? source[type].filter(itm => isFilterMatch(itm, filter)).map(itm => ({
      ...itm,
      fullNumber: source[SUB].find(sub => (sub._id === itm[`_${SUB}`])).fullNumber
    })) : source[type].filter(itm => ((itm._subcategories === _subcategories) && isFilterMatch(itm, filter)))
    // console.log('MAKING SOURCECONTROLLER', _subcategories, langEntries, source[REC])

    let dropdownItems = langEntries.map(itm => (
      <Dropdown.Item key={itm._id} eventKey={itm._id}>
        {showAllLanguageEntries ? `${itm.fullNumber}: ${itm.short}` : itm.short}
      </Dropdown.Item>
    ))
    // console.log('rerendering langEntrySelector with filter and showMenu', !!filter, showMenu, _subcategories, source)
    return (
      <Dropdown key={`${showMenu}`} className="report-language-entry-selector" align="down" onSelect={(eventKey) => {
        const res = source[type].find(itm => itm._id === eventKey)
        console.log('langEntry selected', type, eventKey, res)
        onSelect(res)
      }}>
          <InputGroup style={{display:'inline-flex'}}>
            <Form.Control
              type="text"
              placeholder="Type to filter Language Entries in the Dropdown Menu --->"
              onChange={evt => setFilter(evt.target.value)}
              value={filter}
            />
              <Button
                variant={`${showAllLanguageEntries ? '' : 'outline-'}info`}
                onClick={() => setShowAllLanguageEntries(!showAllLanguageEntries)}
              >
                {`Language: ${showAllLanguageEntries ? 'Full' : 'Specific'}`}
              </Button>
              <Dropdown.Toggle split variant="outline-info" onClick={()=>setShowMenu(!showMenu)}>
              </Dropdown.Toggle>
          </InputGroup>
        <Dropdown.Menu show={showMenu || !!filter} className="report-lang-entry-dropdown">
          {dropdownItems}
        </Dropdown.Menu>
      </Dropdown>
    )
  },  [source, _subcategories, filter, showAllLanguageEntries, showMenu, onSelect, type])

  return langEntrySelectorComponent
}
